import Reveal from "@/components/Reveal";
import { Icon } from "@/components/Icon";
import { WHY_OUTSOURCE } from "@/lib/content";

const WhyOutsource = () => {
  return (
    <section className="bg-white" data-testid="why-outsource">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24 lg:py-28">
        <Reveal className="max-w-2xl">
          <p className="text-[13px] font-semibold uppercase tracking-[0.18em] text-[#4B5CAB]">
            Why outsource
          </p>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl font-bold tracking-[-0.02em] text-[#2A2E7A] leading-[1.15]">
            Focus on your business — leave the bookkeeping to us
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {WHY_OUTSOURCE.map((b, i) => (
            <Reveal key={b.title} delay={i * 0.1}>
              <div
                data-testid={`outsource-card-${b.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="group h-full bg-white p-8 lg:p-9 rounded-lg border border-[#2A2E7A]/8 shadow-[0_1px_2px_rgba(36,59,99,0.04)] transition-[box-shadow,transform,border-color] duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_24px_48px_-24px_rgba(36,59,99,0.28)] hover:border-[#4B5CAB]/25"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-[8px] bg-[#F5F6FB] border border-[#2A2E7A]/8 transition-colors duration-300 group-hover:bg-[#2A2E7A]">
                  <Icon name={b.icon} className="h-6 w-6 text-[#2A2E7A] transition-colors duration-300 group-hover:text-white" strokeWidth={1.6} />
                </span>
                <h3 className="mt-6 font-heading text-xl font-semibold text-[#2A2E7A] tracking-[-0.01em]">
                  {b.title}
                </h3>
                <p className="mt-3 text-[15px] text-[#51607A] leading-[1.75]">{b.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyOutsource;
